import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";

const Header = () => {
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });

    localStorage.removeItem("auth");
    navigate("/login");
  };

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary shadow-sm">
      <div className="container-fluid">

        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img src="/images/antya.png" alt="Antya Logo" height="40" />
        </Link>

        {/* Mobile Toggle */}
        <button
          onClick={toggleNavbar}
          className="navbar-toggler"
          type="button"
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* Navbar */}
        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          id="navbarMain"
        >
          <ul className="navbar-nav ms-auto">

            {/* Home */}
            <li className="nav-item">
              <NavLink className="nav-link" to="/">
                Home
              </NavLink>
            </li>

            {!auth?.user ? (
              <li className="nav-item">
                <NavLink className="nav-link" to="/login">
                  Login
                </NavLink>
              </li>
            ) : (
              <>
                {/* Category */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    data-bs-toggle="dropdown"
                  >
                    Category
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/add-category"
                      >
                        Add Category
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/category-list"
                      >
                        Category List
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* Fabric */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    data-bs-toggle="dropdown"
                  >
                    Fabric
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/add-fabric"
                      >
                        Add Fabric
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/fabric-list"
                      >
                        Fabric List
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/than-transfer-from-warehouse"
                      >
                        Than Transfer From Warehouse
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/intransit-than-list"
                      >
                        Intransit Than List
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/fabric-ims"
                      >
                        Fabric IMS
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/item-listing"
                      >
                        Item List
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/item-listing-for-fabric"
                      >
                        Item List for Fabric
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/fabric-recover-list"
                      >
                        Recovered Fabric History
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* Kali/Dupatta */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    data-bs-toggle="dropdown"
                  >
                    Kali/Dupatta
                  </button>

                  <ul className="dropdown-menu">

                  <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/add-dupatta-kali"
                      >
                        Add Kali/Dupatta
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/dupatta-kali-list"
                      >
                        Kali/Dupatta List
                      </NavLink>
                    </li>
                    
                  <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/add-po-elements"
                      >
                        Add PO(Kali/Dupatta)
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/elements-po-listing"
                      >
                       Po Listing(Kali/Dupatta)
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/po-inward-element-list"
                      >
                       Po Inward Listing(Kali/Dupatta)
                      </NavLink>
                    </li>

                    
                  </ul>
                </li>


                {/* Purchase Order */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    data-bs-toggle="dropdown"
                  >
                    Purchase Order
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/add-po"
                      >
                        Add PO
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/po-list"
                      >
                        PO List
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/po-inward-list"
                      >
                        PO Inward List
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/dashboard/all-po-inward-list"
                      >
                        All PO Inward List
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* User */}
                <li className="nav-item dropdown">
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    data-bs-toggle="dropdown"
                  >
                    {auth?.user?.name}
                  </button>

                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </li>
                  </ul>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;